import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-unauthorized-error',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UnauthorizedErrorComponent {}
